import type { ReactNode } from "react";

// Box-internal section header. Sits as the first child of a padded `.box`,
// title left, optional right slot (count, toggle, link). Replaces the old
// "title above the box" convention; see docs/UI_CONVENTIONS.md.
//
// Variants:
//   default - `text-lg font-medium` (18px). The everyday section header.
//   hero    - `text-5xl leading-none tracking-tight` (~48px). Used on
//             landing-style boxes (e.g. Save · Service "Input"/"Output"/
//             "Documents") where the box is the visual centrepiece. Same
//             font family as `default`, only the size changes.

interface BoxHeaderProps {
  title?: ReactNode;
  right?: ReactNode;
  className?: string;
  variant?: "default" | "hero";
}

export function BoxHeader({ title, right, className = "", variant = "default" }: BoxHeaderProps) {
  const titleCls =
    variant === "hero"
      ? "text-5xl font-medium leading-none tracking-tight text-ink"
      : "text-lg font-medium text-ink";
  const wrapperCls =
    variant === "hero"
      ? "mb-3 flex items-start justify-between gap-3"
      : "mb-4 flex min-h-7 items-center justify-between gap-3";
  return (
    <div className={`${wrapperCls} ${className}`}>
      {title != null ? <div className={titleCls}>{title}</div> : null}
      {right != null ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}
